import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import {
  SelectorOptions,
  TitlePrimary,
  View,
  SpacerVertical,
  ParagraphSecondary,
  ButtonPrimary,
  SpacerHorizontal,
} from '@klarna/bubble-ui';
import { selectors as i18nSelectors } from 'mage-i18n';
import { selectors as stateSelectors } from 'mage-state';

import { Modal } from '@klarna/mp-ui';

const tPrefix = 'moet-core.select_language';

const languageToOption = translatorFactory => language => ({
  value: language,
  id: `app-language-option-${language}`,
  // use the factory so we can display the language name in its own language
  label: translatorFactory(language)(`core.languages.${language}`),
});

const SelectLanguageDialog = ({
  t,
  translatorFactory,
  language,
  languages,
  saveLanguage,
  onClose,
}) => {
  return (
    <Modal
      id="select-language"
      onClose={onClose}
      rightIconAriaLabel="close"
      onBackgroundClick={onClose}
    >
      <View>
        <TitlePrimary small correctFootprint centered>
          {t(`${tPrefix}.title`)}
        </TitlePrimary>
        <SpacerVertical small />
        <SpacerVertical small />
        <ParagraphSecondary correctFootprint centered>
          {t(`${tPrefix}.paragraph`)}
        </ParagraphSecondary>
      </View>

      <SpacerVertical large />

      <View>
        <SelectorOptions
          options={languages.map(languageToOption(translatorFactory))}
          defaultValue={language}
          onSelect={saveLanguage}
        />
        <SpacerHorizontal small />
        <ButtonPrimary onClick={onClose}>{t(`${tPrefix}.submit`)}</ButtonPrimary>
      </View>
    </Modal>
  );
};

SelectLanguageDialog.propTypes = {
  language: PropTypes.string,
  languages: PropTypes.arrayOf(PropTypes.string),
  saveLanguage: PropTypes.func,
  t: PropTypes.func,
  translatorFactory: PropTypes.func,
  onClose: PropTypes.func,
};

export default connect(state => ({
  t: i18nSelectors.translator(state),
  translatorFactory: i18nSelectors.translatorFactory(state),
  language: i18nSelectors.language(state),
  languages: stateSelectors.getLanguages(state),
}))(SelectLanguageDialog);
